import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-432aed4a")

_pushScopeId("data-v-432aed4a")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-info d-flex align-items-start mt-5 mb-0"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "bi bi-info-circle fs-4 me-3 mt-1" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "col-md-12 mt-5"
}
const _hoisted_6 = { class: "d-flex align-items-center fs-5 fw-bolder mb-3" }
const _hoisted_7 = {
  key: 2,
  class: "row mt-5"
}
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.integrationFormData,
    ref: "integrationFormRef"
  }, {
    default: _withId(() => [
      _createVNode(_component_InnerLoader, {
        loading: _ctx.loader,
        innerLoading: true
      }, null, 8, ["loading"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Select, {
            name: "shipping_method",
            target: "shipping_method",
            label: _ctx.$t('message.SHIPPING_METHOD'),
            placeholder: "Please Select",
            shipping_method: _ctx.integrationFormData.shipping_method,
            "onUpdate:shipping_method": _cache[1] || (_cache[1] = ($event: any) => (_ctx.integrationFormData.shipping_method = $event)),
            selectData: _ctx.shippingMethod,
            value: _ctx.integrationFormData.shipping_method,
            callEmit: true,
            clearable: true,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onShippingMethodChange()))
          }, null, 8, ["label", "shipping_method", "selectData", "value"])
        ])
      ]),
      (_ctx.integrationFormData.shipping_method == 'MONTONIO')
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("span", null, _toDisplayString(_ctx.$t('message.MONTONIO_SYNC_HINT')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.integrationFormData.shipping_method == 'MONTONIO')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('message.WANT_TO_PICKUP')), 1),
            _createVNode("div", null, [
              _createVNode(_component_Radio, {
                name: "is_pickup",
                size: "medium",
                target: "is_pickup",
                value: _ctx.integrationFormData.is_pickup,
                is_pickup: _ctx.integrationFormData.is_pickup,
                "onUpdate:is_pickup": _cache[3] || (_cache[3] = ($event: any) => (_ctx.integrationFormData.is_pickup = $event)),
                display: "block",
                options: _ctx.pickups,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePickUp()))
              }, null, 8, ["value", "is_pickup", "options"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMontonioServicePoint)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_Select, {
                name: "types",
                target: "types",
                label: _ctx.$t('message.TYPE'),
                placeholder: "Please Select",
                types: _ctx.integrationFormData.types,
                "onUpdate:types": _cache[5] || (_cache[5] = ($event: any) => (_ctx.integrationFormData.types = $event)),
                selectData: _ctx.montonioTypes,
                value: _ctx.integrationFormData.types,
                callEmit: true,
                filterable: false,
                clearable: false,
                disabled: true,
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.integrationFormData.carriers = ''))
              }, null, 8, ["label", "types", "selectData", "value"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_Select, {
                name: "carriers",
                target: "carriers",
                label: _ctx.$t('message.CARRIERS'),
                placeholder: "Please Select",
                carriers: _ctx.integrationFormData.carriers,
                "onUpdate:carriers": _cache[7] || (_cache[7] = ($event: any) => (_ctx.integrationFormData.carriers = $event)),
                selectData: _ctx.montonioCarriers,
                value: _ctx.integrationFormData.carriers,
                callEmit: true,
                filterable: true,
                clearable: true,
                required: true
              }, null, 8, ["label", "carriers", "selectData", "value"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model"]))
})